export default "__VITE_ASSET__62ca5c7d__"